module.exports = __webpack_public_path__ + "img/quick-label-print-ru.49bb4d53.jpg";